export default __webpack_public_path__ + "static/media/exchange.f19849eb.svg";